import { useState } from 'react'
import {
    Inbox,
    FileText,
    Repeat,
    Settings as SettingsIcon,
    Megaphone,
    ShieldX,
    Newspaper,
    FlaskConical,
} from 'lucide-react'
import { DeliveryLogTab } from './DeliveryLogTab'
import { SuppressionsTab } from './SuppressionsTab'
import { SettingsTab } from './SettingsTab'
import { TemplatesTab } from './TemplatesTab'
import { CampaignsTab } from './CampaignsTab'
import { BroadcastsTab } from './BroadcastsTab'
import { DigestsTab } from './DigestsTab'
import { ExperimentsTab } from './ExperimentsTab'

type TabKey =
    | 'deliveries'
    | 'templates'
    | 'campaigns'
    | 'broadcasts'
    | 'digests'
    | 'experiments'
    | 'suppressions'
    | 'settings'

interface TabDef {
    key: TabKey
    label: string
    icon: React.ComponentType<{ className?: string }>
}

const TABS: TabDef[] = [
    { key: 'deliveries', label: 'Delivery Log', icon: Inbox },
    { key: 'templates', label: 'Templates', icon: FileText },
    { key: 'campaigns', label: 'Campaigns', icon: Repeat },
    { key: 'broadcasts', label: 'Broadcasts', icon: Megaphone },
    { key: 'digests', label: 'Digests', icon: Newspaper },
    { key: 'experiments', label: 'Experiments', icon: FlaskConical },
    { key: 'suppressions', label: 'Suppressions', icon: ShieldX },
    { key: 'settings', label: 'Settings', icon: SettingsIcon },
]

export default function CommunicationsPage() {
    const [tab, setTab] = useState<TabKey>('deliveries')

    return (
        <div className="space-y-6 text-left">
            <div>
                <h1 className="text-2xl font-bold text-gray-900">Communications</h1>
                <p className="mt-1 text-sm text-gray-500">
                    Audit, configure, and orchestrate every email Libra sends.
                </p>
            </div>

            <div className="border-b border-gray-200">
                <nav className="-mb-px flex flex-wrap gap-x-6">
                    {TABS.map(t => {
                        const Icon = t.icon
                        const active = tab === t.key
                        return (
                            <button
                                key={t.key}
                                onClick={() => setTab(t.key)}
                                className={`group inline-flex items-center gap-2 whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors ${
                                    active
                                        ? 'border-blue-600 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                                }`}
                            >
                                <Icon className="h-4 w-4" />
                                {t.label}
                            </button>
                        )
                    })}
                </nav>
            </div>

            <div>
                {tab === 'deliveries' && <DeliveryLogTab />}
                {tab === 'templates' && <TemplatesTab />}
                {tab === 'campaigns' && <CampaignsTab />}
                {tab === 'broadcasts' && <BroadcastsTab />}
                {tab === 'digests' && <DigestsTab />}
                {tab === 'experiments' && <ExperimentsTab />}
                {tab === 'suppressions' && <SuppressionsTab />}
                {tab === 'settings' && <SettingsTab />}
            </div>
        </div>
    )
}
